export enum COMPARISON_TYPES {
  EQUAL = 'EQUAL',
  NOT_EQUAL = 'NOT EQUAL',
  GREATER_THAN = 'GREATER THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER THAN OR EQUAL',
  LESS_THAN = 'LESS THAN',
  LESS_THAN_OR_EQUAL = 'LESS THAN OR EQUAL',
}
